import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  value: "选中项",
  dates:"日期",
  startDate:"时间区间",
  endDate:"结束时间"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
